import HttpService from "./HttpService";
import { api } from "../common/enviroment";

export default class ClientBranchService {
  httpService = new HttpService();

  get = (id) => {
    return this.httpService.get(`/services/app${api.CLIENTBRANCH_SERVICE}/Get?Id=${id}`);
  };

  getBranchesByClientId = (clientId) => {
    return this.httpService.get(`/services/app${api.CLIENTBRANCH_SERVICE}/GetBranchesByClientId?clientId=${clientId}`);
  };

  getAll = (maxResultCount, skipCount, search) => {
    return this.httpService.get(`/services/app${api.CLIENTBRANCH_SERVICE}/GetAll?${maxResultCount ? "MaxResultCount="+maxResultCount+"&" : ""}${skipCount ? "SkipCount="+skipCount+"&" : ""}${search ? "Search="+search+"&" : ""}`);
  };

  delete = (id) => {
    return this.httpService.delete(`/services/app${api.CLIENTBRANCH_SERVICE}/Delete?Id=${id}`);
  }

  create = (data) => {
    return this.httpService.post(`/services/app${api.CLIENTBRANCH_SERVICE}/Create`, data);
  }

  update = (data) => {
    return this.httpService.put(`/services/app${api.CLIENTBRANCH_SERVICE}/Update`, data);
  }
}

